import { WebAuth } from 'auth0-js';

let webauth = new WebAuth({
  domain:'verbtech.auth0.com',
  responseType: "token",
  clientID: 'PsDnj6VvzdpVEPIQIpuomS54dkQZwNA8',
  redirectUri: "http://localhost:3000/auth/login",
  
});

export function authorizeLogin(authtype:any, callback:any) {
    webauth.popup.authorize({
      connection: authtype,
      domain: "verbtech.auth0.com",
      redirectUri: "http://localhost:3000/auth/login",
      responseType: "token",
      
owp: true,
    }, function(err, authResult) {
     // console.log("Result===>$$$",authResult)
     // console.log("err===>$$$",err)
      if (err) {

      } else {
        localStorage.setItem("jwt_token", authResult.idToken ?? "");
        callback();
      }
      
    });
}



